import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import * as Sentry from "@sentry/react";
//import { BrowserTracing } from "@sentry/tracing";

// Initialize Sentry with more complete configuration
Sentry.init({
  dsn: "https://05208da0c30643da7d38797e75b93489@o4509074689556480.ingest.us.sentry.io/4509076052443136"
});

// Fix the duplicate rendering by removing one of them
// Only use one root.render call
const rootElement = document.getElementById('root') || document.getElementById('app');
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);